import { FC } from 'react';

interface TextWithTooltipProps {
  content: string;
  type?: 'text' | 'boolean';
  tooltip?: boolean;
  maxLength?: number;
}

const TextWithTooltip: FC<TextWithTooltipProps> = ({
  content = '',
  type = 'text',
  tooltip = true,
  maxLength = 40,
}) => {
  if (type === 'boolean') {
    return content ? (
      <i className="pi pi-paperclip ml-2 text-primary" aria-label="attachment icon" />
    ) : null;
  }

  if (type === 'text') {
    const isTruncated = content.length > maxLength;
    const displayText = isTruncated ? `${content.substring(0, maxLength - 1)}...` : content;

    return <span title={tooltip ? content : undefined}>{displayText}</span>;
  }

  return <span>{content}</span>;
};

export default TextWithTooltip;
